import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RtAnalyticsModule } from '@recruitee/analytics';

import { TooltipModule } from '../tooltip/tooltip.module';
import { AdminsAvatarsComponent } from './admins-avatars.component';

@NgModule({
  imports: [CommonModule, RtAnalyticsModule, TooltipModule, AdminsAvatarsComponent],
  exports: [AdminsAvatarsComponent],
})
export class AdminsAvatarsModule {}

export { AdminsAvatarsComponent } from './admins-avatars.component';
